'use client';

import { c } from '../../../utils/tailwind-merge';
import { UserReviewInfo } from '../../molecules/UserReviewInfo';
import { UserReview } from '../UserReview';
import { UserProductReviewProps } from './UserProductReview.types';

export const UserProductReview = ({
  reviewerInfo,
  reviewDetails,
  onSubmitReport,
  onEditReview,
  onDeleteReview,
  onEditReply,
  onDeleteReply,
  onSubmitReply,
  microcopy,
  className,
}: UserProductReviewProps) => {
  return (
    <div className={c('block w-full gap-5 md:flex', className)}>
      <UserReviewInfo
        {...reviewerInfo}
        microcopy={microcopy.reviewerInfo}
        className="mb-5 w-44 md:mb-0"
      />
      <UserReview
        onSubmitReport={onSubmitReport}
        onEditReview={onEditReview}
        onDeleteReview={onDeleteReview}
        onEditReply={onEditReply}
        onDeleteReply={onDeleteReply}
        onSubmitReply={onSubmitReply}
        {...reviewDetails}
        microcopy={microcopy.reviewDetails}
      />
    </div>
  );
};
